<template>
    <div style="border-bottom: 1px solid rgba(55, 53, 47, 0.09); margin-bottom: 16px; margin-top: 0; padding-bottom: 12px; font-size: 16px; font-weight: 500; width: auto; color: rgb(55, 53, 47);">
        <slot></slot>
    </div>
</template>